import dayjs from 'dayjs';
import React from 'react';
import { Line } from 'react-chartjs-2';
import { shortenNumbers } from '../../../../utils/shortenNumbers';
import styles from './TotalSalesChart.module.scss';
import { numberWithCommas } from '../../../../utils/numberWithCommas';

const TotalSalesChart = ({ salesData, timesData, netSalesData }) => {
	const options = {
		scales: {
			y: {
				min: 0,
				ticks: {
					callback: function (value, index, values) {
						return '$' + shortenNumbers(value, 1);
					},
				},
			},
			x: {
				grid: {
					display: false,
				},
			},
		},
		plugins: {
			legend: {
				display: false,
			},
		},
		animation: false,
		responsive: true,
		maintainAspectRatio: false,
	};

	let labelsArr = timesData?.map((time) => time);
	let dataArr = salesData?.map((sale) => sale);
	if (labelsArr && dataArr && labelsArr.length === 1) {
		labelsArr.unshift('');
		dataArr.unshift(dataArr[0]);
	}

	console.log('This is the sales data', salesData);

	const data = {
		labels: labelsArr,
		datasets: [
			{
				label: 'Total Sales',
				data: dataArr,
				fill: true,
				borderColor: 'rgba(67, 138, 254, 1)',
				backgroundColor: 'rgba(67, 138, 254, 0.2)',
				datalabels: {
					display: false, // hide data number on chart
				},
			},
		],
	};

	return (
		<div className={styles.total_sales_chart}>
			{(timesData && timesData.length === 0) ||
			timesData === undefined ? (
				<div className={styles.noSales}>No results found.</div>
			) : (
				<>
					<div
						style={{
							position: 'absolute',
							top: 16,
							right: 16,
							display: 'flex',
							flexDirection: 'column',
						}}
					>
						<span style={{ fontWeight: 700, color: '#979797' }}>
							Net Sales
						</span>
						<span style={{ fontWeight: 700, color: '#29be67' }}>
							$ {numberWithCommas(netSalesData)}
						</span>
					</div>
					<div>
						<Line options={options} data={data} height={280} />
					</div>
				</>
			)}
		</div>
	);
};

export default TotalSalesChart;
